import { BoxesIcon } from "@lucide/icons";

import { H3 } from "simplydo/react/ui/header";
import { Icon } from "simplydo/react/ui/icon";

import { crunchbaseImageUrl } from "utils/companies";

import type { CompanyOwnership } from "components/innointel/types";

import {
  InfoBoxWidget,
  InfoBoxWidgetTitleArea,
  InfoContainer,
  InfoItem,
  KeyFactLink,
} from "../Styles";

type CompanyChildOwnershipsProps = { childOwnerships: CompanyOwnership[] };

const CompanyChildOwnerships = ({
  childOwnerships,
}: CompanyChildOwnershipsProps) => {
  if (childOwnerships.length) {
    return (
      <InfoBoxWidget $noBox style={{ maxHeight: 520, overflow: "auto" }}>
        <InfoBoxWidgetTitleArea>
          <Icon icon={BoxesIcon} />
          <div>
            <H3>Ownerships & Subsidiaries</H3>
            <span>{childOwnerships.length} found</span>
          </div>
        </InfoBoxWidgetTitleArea>
        <InfoContainer $wrapped>
          {childOwnerships.map((child) => (
            <InfoItem $compact key={child.ownee_identifier?.uuid}>
              <KeyFactLink
                image={`${crunchbaseImageUrl}${child.ownee_identifier?.image_id ?? ""}`}
                title={child.ownee_identifier?.value ?? "Unknown"}
                fact={`Type: ${child.ownership_type?.toUpperCase() ?? "UNKNOWN"}`}
              />
            </InfoItem>
          ))}
        </InfoContainer>
      </InfoBoxWidget>
    );
  }
  return null;
};

export default CompanyChildOwnerships;
